
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.122 2H5.051C4.471 2 4 2.456 4 3.016v2.846c0 .162.136.293.303.293a.298.298 0 00.303-.293V3.016c0-.237.2-.43.445-.43h.588v16.698h-.588a.438.438 0 01-.445-.43V7.23a.298.298 0 00-.303-.293A.298.298 0 004 7.23v11.625c0 .56.471 1.016 1.051 1.016h.588v1.724c0 .16.099.306.25.371.152.065.33.038.453-.07l.883-.777.884.777c.123.108.3.135.452.07a.406.406 0 00.25-.37V19.87h3.273a.298.298 0 00.303-.293.298.298 0 00-.303-.293H6.246V2.586h8.449v1.812h-5.64a.605.605 0 00-.614.594v1.99c0 .327.276.594.614.594h5.64v11.708h-1.196a.298.298 0 00-.303.293c0 .162.135.293.303.293h3.623c1.036 0 1.878-.814 1.878-1.815V3.815C19 2.814 18.158 2 17.122 2zM8.204 19.87v1.317l-.697-.613a.429.429 0 00-.564 0l-.697.613V19.87h1.958zm.851-12.88a.008.008 0 01-.008-.008v-1.99c0-.005.004-.008.008-.008h5.64V6.99h-5.64zm6.246-4.404h1.181v16.698h-1.181V2.586zm3.093 15.47c0 .677-.57 1.228-1.272 1.228h-.034V2.586h.034c.701 0 1.272.551 1.272 1.229v14.24z"}})])
          )
        }
      }
    